export default __webpack_public_path__ + "alberta-activity-date.218f03920cee099e15c7.svg";